import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Modal } from 'react-bootstrap';
import LoadingOverlay from 'react-loading-overlay';
import { View } from 'react-native-web';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { Logo } from '../../../Resources/Images/ImagesLogo';
import { GeneralFooterRegister } from '../../Atoms/GeneralFooter/GeneralFooter';
import ButtonRedirect from '../../Atoms/ButtonRedirect/ButtonRedirect';
import { recaptchaSiteKey } from '../../../Domain/Settings/Keys/Keys';
import { LOGIN } from '../../../Domain/Redux/Actions/ActionTypes/ActionTypes';
import { generalAction } from '../../../Domain/Redux/Actions/Actions/Actions';
import {
  LOGIN_SOCIAL_PATH,
  FRONTEND_URL,
  API_CODE_VERIFICATION,
  REGISTER_PATH,
  API_VALIDATE_CREATE_USER,
  API_ENRROLMENT_VALIDATION_FORM
} from '../../../Domain/Redux/Paths';
import './AccountVerification.css';
import '../../../Generals/Styles/FormContainerStyle.css';
import InfoErrorCode from '../../Atoms/InfoErrorCode/InfoErrorCode';
import HeaderModal from '../../Atoms/HeaderModal/HeaderModal';
import Timer from '../../Atoms/Timer/Timer';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import {
  useGetComponentParameters,
  useGetComponentParametersSingle
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import {
  ID_SYSTEM_INFORMATION,
  TYPE_FETCH_PARAMETERS
} from '../../../Domain/Settings/Constants/Constants';
import { useCombinedObjects } from '../../../Domain/Utils/ApiUtilies/Parameters/Parameters';

const AccountVerification = ({
  email,
  system = false,
  onCloseModal,
  onFinish = false,
  isPortal = false,
  dataPayload = {},
  colorText = '#000',
  isReference = false,
  onReturn = () => {}
}) => {
  const reg = new RegExp('^[0-9]$');
  const dispatch = useDispatch();
  const [time, setTime] = useState(false);
  const userData = useSelector((state) => state.userData);
  const language = useSelector((state) => state.languageTraslate.language.id);

  const status = useSelector((state) => state.status);
  const [isActive, setIsActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);

  const parametersMlt = useGetComponentParameters(COMPONENTS.ACCOUNT_VERIFICATION);
  const parametersStd = useGetComponentParametersSingle(
    COMPONENTS.ACCOUNT_VERIFICATION,
    TYPE_FETCH_PARAMETERS.STANDARD
  );
  const parameters = useCombinedObjects(parametersMlt, parametersStd);

  const { register, handleSubmit, watch, setValue, reset } = useForm({
    reValidateMode: 'onBlur'
  });

  const btnSubmit = useRef(null);

  useEffect(() => {
    if (system && email) {
      resendCode();
    }
    if (parseInt(parameters?.CODE_TIME?.value) > 0) {
      const timeData = {
        time: parseInt(parameters?.CODE_TIME?.value) || 60
      };
      setTime(timeData);
    }
  }, [parameters]);

  useEffect(() => {
    if (status === 401) {
      setIsActive(false);
    }
  }, [status]);

  useEffect(() => {
    if (userData !== '') {
      setIsActive(false);
    }
  }, [userData]);

  useEffect(() => {
    reg.test(watch('code1')) === false && setValue('code1', '');
    watch('code1')?.length > 0 && document.getElementById('code2').focus();
    watch('code1')?.length > 1 && setValue('code1', watch('code1')[0]);
  }, [watch('code1')]);

  useEffect(() => {
    reg.test(watch('code2')) === false && setValue('code2', '');
    watch('code2')?.length > 0 && document.getElementById('code3').focus();
    watch('code2')?.length > 1 && setValue('code2', watch('code2')[0]);
  }, [watch('code2')]);

  useEffect(() => {
    reg.test(watch('code3')) === false && setValue('code3', '');
    watch('code3')?.length > 0 && document.getElementById('code4').focus();
    watch('code3')?.length > 1 && setValue('code3', watch('code3')[0]);
  }, [watch('code3')]);

  useEffect(() => {
    reg.test(watch('code4')) === false && setValue('code4', '');
    watch('code4')?.length > 0 && document.getElementById('code5').focus();
    watch('code4')?.length > 1 && setValue('code4', watch('code4')[0]);
  }, [watch('code4')]);

  useEffect(() => {
    reg.test(watch('code5')) === false && setValue('code5', '');
    watch('code5')?.length > 0 && document.getElementById('code6').focus();
    watch('code5')?.length > 1 && setValue('code5', watch('code5')[0]);
  }, [watch('code5')]);

  useEffect(() => {
    reg.test(watch('code6')) === false && setValue('code6', '');
    watch('code6')?.length > 1 && setValue('code6', watch('code6')[0]);
    if (
      watch('code1')?.length > 0 &&
      watch('code2')?.length > 0 &&
      watch('code3')?.length > 0 &&
      watch('code4')?.length > 0 &&
      watch('code5')?.length > 0 &&
      watch('code6')?.length > 0
    ) {
      btnSubmit.current.click();
    }
  }, [watch('code6')]);

  const onSubmit = async (data) => {
    setIsActive(true);
    const code = data.code1 + data.code2 + data.code3 + data.code4 + data.code5 + data.code6;

    if (isPortal) {
      const firstName = dataPayload?.firstName?.trim() ?? dataPayload?.first_name?.trim();
      const lastName = dataPayload?.lastName?.trim() ?? dataPayload?.last_name?.trim();
      const payloadRegister = {
        email: String(email?.trim()),
        first_name: firstName,
        last_name: lastName,
        code,
        system: ID_SYSTEM_INFORMATION.PORTAL,
        multilanguage_id: language,
        component_reference: COMPONENTS.REFERENCE_TYPES,
        component_city: COMPONENTS.CITY,
        component: COMPONENTS.COUNTRY,
        component_phone_type: COMPONENTS.PHONE_TYPE
      };

      HttpClient.POST(API_VALIDATE_CREATE_USER, payloadRegister)
        .then((res) => {
          if (res?.user_id) {
            setIsActive(false);
            onFinish(res);
            return;
          }
          if (!res?.valid_code) {
            setModalError(true);
            document.getElementById('code1').focus();
            return;
          }
        })
        .catch(() => {
          setIsActive(false);
          setModalError(true);
          document.getElementById('code1').focus();
        })
        .finally(() => {
          setIsActive(false);
        });

      return;
    }
    if (isReference) {
      const payloadRegister = {
        ...dataPayload,
        email: String(email?.trim()),
        first_name: dataPayload.firstName.trim(),
        last_name: dataPayload.lastName.trim(),
        code_verification: code,
        system: ID_SYSTEM_INFORMATION.PORTAL,
        verify: true,
        multilanguage_id: language,
        component_reference: COMPONENTS.REFERENCE_TYPES,
        component_city: COMPONENTS.CITY,
        component: COMPONENTS.COUNTRY
      };

      try {
        const res = await HttpClient.POST(API_ENRROLMENT_VALIDATION_FORM, payloadRegister);
        if (res?.content) {
          onFinish({ ...res, code_verification: code });
          setIsActive(false);
          return;
        } else {
          setIsActive(false);
          setModalError(true);
          document.getElementById('code1').focus();
          return;
        }
      } catch (error) {
        return;
      } finally {
        setIsActive(false);
      }
    }

    HttpClient.PATCH(REGISTER_PATH, {
      code: code,
      email: email,
      multilanguageId: language
    }).then((response) => {
      if (response.content === false) {
        document.getElementById('code1').focus();
        setIsActive(false);
        setModalError(true);
        return;
      }
      handleClickSuccess();
    });
  };

  const responseSocialAuth = (data, type) => {
    if (Object.hasOwnProperty.call(data, 'accessToken')) {
      setIsActive(true);
      window.grecaptcha.ready((e) => {
        window.grecaptcha.execute(recaptchaSiteKey, { action: 'homepage' }).then((token) => {
          window.localStorage.setItem('reCaptcha', token);
          dispatch(
            generalAction(LOGIN_SOCIAL_PATH, LOGIN, null, 'POST', {
              access_token: data.accessToken,
              provider: type
            })
          );
        });
      });
    }
  };

  // reset form handle
  const resetForm = () => {
    setShowModal(false);
    setModalError(false);
    reset({
      code1: '',
      code2: '',
      code3: '',
      code4: '',
      code5: '',
      code6: ''
    });
  };

  // click success handle
  const handleClickSuccess = () => {
    if (onFinish) {
      onFinish();
    } else {
      window.location.href = FRONTEND_URL + '/services';
    }
  };

  // go back handle
  const handleClickReturn = () => {
    if (onFinish) {
      onCloseModal(false);
      onReturn();
    } else {
      window.location.href = FRONTEND_URL + '/createaccount';
    }
  };

  // keyboard action handle
  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      if (document.getElementById(document.activeElement.id).value.length === 0) {
        const id = 'code' + (Number(document.activeElement.id[4]) - 1);
        document.getElementById(id).focus();
      }
    }
  };

  // make request for getting a new code
  const resendCode = () => {
    setIsActive(true);
    resetForm();
    HttpClient.POST(API_CODE_VERIFICATION, {
      email: email,
      multilanguageId: language
    })
      .then(() => {
        isStart && setShowModal(true);
        reset({
          code1: '',
          code2: '',
          code3: '',
          code4: '',
          code5: '',
          code6: ''
        });
      })
      .catch((error) => {
        console.debug('Error: ', error);
      })
      .finally(() => setIsActive(false));
  };

  return (
    <LoadingOverlay active={isActive} spinner text="Cargando ...">
      <Modal backdrop="static" keyboard={false} show={showModal} onHide={resetForm}>
        <HeaderModal
          title={parameters?.INF_MSG_4?.value || 'Información'}
          subtitle={parameters?.INF_MSG_4?.description_value || 'Subtitle Información'}
        />
        <Modal.Body>
          <div className="d-flex w-100" style={{ fontSize: '18px' }}>
            {parameters?.INF_MSG_5?.value?.split('-')[0] ||
              'Se envió código de seguridad al correo electrónico registrado, con vigencia de'}
            <b style={{ fontWeigth: 'bold' }}>
              <Timer duration={parseInt(time.time)} />
              {parameters?.INF_MSG_5?.value?.split('-')[1] || 'minutos.'}
            </b>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button style={styles.btnModal} variant="warning" onClick={resetForm}>
            {parameters?.INF_MSG_6?.value || 'Cerrar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* modal codigo incorrecto eliminado*/}

      <Modal show={modalSuccess} onHide={() => setModalSuccess(false)}>
        <HeaderModal
          title={parameters?.INF_MSG_4?.value || 'Información'}
          subtitle={parameters?.INF_MSG_4?.description_value || 'Subtitle Información'}
          warning
        />
        <Modal.Body className="text-center" style={{ fontSize: '18px' }}>
          {parameters?.INF_MSG_7?.value || 'Cuenta verificada con éxito'}
        </Modal.Body>
        <Modal.Footer>
          <Button style={styles.btnModal} variant="warning" onClick={handleClickSuccess}>
            {parameters?.INF_MSG_8?.value || 'Aceptar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <div style={onFinish ? { color: colorText } : { color: '#fff' }}>
        {!onFinish && <Logo class="mb-3" />}

        {modalError && <InfoErrorCode message={parameters?.INCORRECT_CODE?.value} />}

        <div className="mb-3 mt-4 px-4" style={{ textAlign: 'center', fontSize: '16px' }}>
          <p style={{ fontSize: '16px' }}>
            {parameters?.INF_MSG_48?.value?.split('-')[0] ||
              'Se envió un código único de seguridad a'}{' '}
            <b style={{ fontWeigth: 'bold' }}>{email}</b>{' '}
            {parameters?.INF_MSG_48?.value?.split('-')[1] || 'para confirmar tu identidad.'}
          </p>
        </div>

        <div className="mt-2 px-4">
          <p style={{ fontSize: '16px' }} className="text-center">
            {parameters?.INF_MSG_52?.value ||
              'Si no encuentras el correo electrónico, asegúrate de revisar la carpeta de Spam.'}
          </p>
        </div>

        <div className="mx-auto">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="numbers-code" onKeyDown={handleKeyDown}>
              <input
                ref={register({
                  required: parameters?.RQD_MSG_4?.value || 'Valor requerido'
                })}
                id="code1"
                type="text"
                name="code1"
              />
              <input
                ref={register({
                  required: parameters?.RQD_MSG_4?.value || 'Valor requerido'
                })}
                id="code2"
                type="text"
                name="code2"
              />
              <input
                ref={register({
                  required: parameters?.RQD_MSG_4?.value || 'Valor requerido'
                })}
                id="code3"
                type="text"
                name="code3"
              />
              <input
                ref={register({
                  required: parameters?.RQD_MSG_4?.value || 'Valor requerido'
                })}
                id="code4"
                type="text"
                name="code4"
              />
              <input
                ref={register({
                  required: parameters?.RQD_MSG_4?.value || 'Valor requerido'
                })}
                id="code5"
                type="text"
                name="code5"
              />
              <input
                ref={register({
                  required: parameters?.RQD_MSG_4?.value || 'Valor requerido'
                })}
                id="code6"
                type="text"
                name="code6"
              />
            </div>
            <button type="submit" ref={btnSubmit} style={{ display: 'none' }} />

            <div>
              <p className="text-center d-flex justify-content-center">
                {parameters?.INF_MSG_49?.value?.split('-')[0] || 'Estará vigente solo por'}
                <b style={{ paddingRight: '5px', paddingLeft: '5px' }}>
                  <Timer duration={parseInt(time.time)} />
                </b>
                <b>{parameters?.INF_MSG_49?.value?.split('-')[1] || 'minutos.'}</b>
              </p>
            </div>

            <div style={{ minHeight: '70px' }} className="row px-2">
              <div className="d-flex px-2 gap-2">
                <div className="flex-fill">
                  <ButtonRedirect
                    onClick={resendCode}
                    title="Reenviar código"
                    className="text-nowrap"
                  />
                </div>
                <div className="flex-fill">
                  <ButtonRedirect
                    onClick={handleClickReturn}
                    title="Regresar"
                    className="text-nowrap"
                  />
                </div>
              </div>
            </div>
          </Form>
        </div>

        <div style={onFinish ? {} : { marginBottom: '50px', marginTop: '30px' }}>
          {!onFinish && (
            <>
              <GeneralFooterRegister parameters={parameters} />

              <View style={{ textAlign: 'center', marginBottom: '5px' }}>
                <p className="pt-3">
                  <b style={{ fontSize: '24px' }}>
                    {parameters?.INF_MSG_86?.value || 'O inicie sesión con:'}
                  </b>
                </p>
              </View>
            </>
          )}
        </div>
      </div>
    </LoadingOverlay>
  );
};

const styles = {
  errorPasswordEye: {
    color: '#dc3545',
    position: 'absolute',
    right: '35px',
    marginTop: '17px',
    cursor: 'pointer'
  },
  passwordEye: {
    color: 'black',
    right: '10px',
    marginTop: '17px',
    position: 'absolute',
    cursor: 'pointer'
  },
  btnResendCode: {
    color: 'black',
    backgroundColor: '#ffe900',
    transition: '0.2s',
    borderColor: '#ffe900',
    borderRadius: '5pc',
    position: 'relative',
    bottom: '60px',
    with: '50%',
    padding: '10px 10px',
    maxWidth: '50%',
    width: '30%'
  },
  btnModal: {
    color: 'black',
    backgroundColor: '#ffe900',
    transition: '0.2s',
    borderColor: '#ffe900',
    borderRadius: '5px',
    width: '30%'
  }
};

export default AccountVerification;
